/**
 * Client-safe: is this URL part of an event preview? The preview link itself
 * and every page of a preview copy, whose slug always ends `-preview-<code>`.
 */
const PREVIEW_PATH =
  /^\/(?:preview\/|hiives\/[^/]+\/events\/[^/]+-preview-[a-z0-9]+(?:\/|$))/;

export function isEventPreviewPath(pathname: string) {
  return PREVIEW_PATH.test(pathname);
}

/**
 * A page that belongs to a preview but whose URL can't say so — a preview
 * booking's wallet ticket lives at `/wallet/events/<id>`. Such a page sets
 * this attribute on `<html>` while it is mounted.
 */
export const PREVIEW_CONTEXT_ATTRIBUTE = "data-hiive-preview";

/** For analytics: is the current page part of an event preview? */
export function isEventPreviewContext() {
  if (typeof window === "undefined") return false;
  return (
    isEventPreviewPath(window.location.pathname) ||
    document.documentElement.hasAttribute(PREVIEW_CONTEXT_ATTRIBUTE)
  );
}
